export const getShortAddress = (address: string) => {
  if (!address) {
    return '';
  }
  const addressParts = address.split(' ');
  return addressParts.slice(0, 2).join(' ');
};
